<template>
    <button
        class="CClose absolute right-2 top-2 z-10 cursor-pointer rounded-full bg-gray-100 dark:bg-subtle p-1 text-gray-700 dark:text-txt-body hover:bg-gray-400 hover:dark:bg-subtle hover:text-black hover:dark:text-txt-headings"
        :disabled="preview"
        @click="close"
    >
        <CIcon name="close" />
    </button>
</template>

<script setup lang="ts">
import CIcon from '@/components/ui/CIcon.vue'

defineProps<{
    preview?: boolean
}>()

const emit = defineEmits<{
    (e: 'close'): void
}>()

const close = () => {
    emit('close')
}
</script>
